export default {
  news: [
    {
      id: 1,
      title: "Wiatromierz",
      briefly: "Telnet wdrożył system pomiaru wiatru pozwalający ocenić opłacalność ekonomiczną przydomowej instalacji wiatrowej.",
      link: "<a href='https://pomiar-wiatru.pl/'>https://pomiar-wiatru.pl/</a>",
      content: null,//"<div class=\"showcase\">\n  Znaczniki HTML są obsługiwane.\n</div>\n<style>\n  .showcase {\n    color: green;\n    font-weight: 700;\n  }\n</style>",
      visible: 1,
      image: {
        name: "luo-lei-Xa4pTwafe5U-unsplash.webp",
        path: "images/luo-lei-Xa4pTwafe5U-unsplash.webp",
        url: "/images/luo-lei-Xa4pTwafe5U-unsplash.webp"
      }
    },
    {
      id: 2,
      title: "Porsche Katowice",
      briefly: "Salon Porsche w Katowicach wybrał firmę Telnet na dostawcę systemu telekomunikacyjnego.",
      content: null,//"<div class=\"showcase\">\n  Znaczniki HTML są obsługiwane.\n</div>\n<style>\n  .showcase {\n    color: green;\n    font-weight: 700;\n  }\n</style>",
      visible: 1,
      image: {
        name: "1632263481.webp",
        path: "images/1632263481.webp",
        url: "/images/1632263481.webp"
      }
    },
    {
      id: 3,
      title: "Dzierżawa systemów telekomunikacyjnych",
      briefly: "Usługa dzierżawy systemów telekomunikacyjnych to gwarancja sprawnego systemu łączności bez kosztów wstępnych.",
      content: null,
      visible: 1,
      image: {
        name: "1632263533.webp",
        path: "images/1632263533.webp",
        url: "/images/1632263533.webp"
      }
    },
    {
      id: 4,
      title: "Silesia City Center",
      briefly: "Telnet wdrożył zintegrowany z systemem ERP  klienta system bilingowy do rozlicze\u0144 energii elektrycznej i usług telekomunikacyjnych.",
      content: null,
      visible: 1,
      image: {
        name: "1632263546.webp",
        path: "images/1632263546.webp",
        url: "/images/1632263546.webp"
      }
    },
    {
      id: 5,
      title: "Tech Park Kanlux najlepszym budynkiem biurowym w Europie!",
      briefly: "TechPark Kanlux, w którym firma Telnet wykonała wszystkie instalacje słaboprądowe zdobył Grand Prix i tytuł Best Office Architecture, otrzymując zaszczytne 5 gwiazdek.",
      content: null,
      visible: 1,
      image: {
        name: "1632263554.webp",
        path: "images/1632263554.webp",
        url: "/images/1632263554.webp"
      }
    },
    {
      id: 6,
      title: "Wdrożenie systemu SAP dla ORAS Olesno",
      briefly: "Telnet wykonał system SAP w oparciu o technologię Siemens dla ORAS Olesno Sp. z o.o.",
      content: null,
      visible: 1,
      image: {
        name: "1632263562.webp",
        path: "images/1632263562.webp",
        url: "/images/1632263562.webp"
      }
    }
  ],
  offerElements: [
    {
      id: 1,
      title: "Sieci komputerowe",
      short: "Projektujemy i tworzymy infrastrukturę strukturalną w oparciu o instalację miedzianą oraz światłowodową.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Posiadamy profesjonalne mierniki do pomiarów okablowania miedzianego jak i światłowodowego. Nasze instalacje są certyfikowane i otrzymują 20 - 25 letnią gwarancję producenta. Okablowanie strukturalne to system uniwersalnego okablowania telekomunikacyjnego, które nie ogranicza się jedynie do sieci komputerowych. Za jego pomocą możemy podłącza\u0107 telefony, urządzenia sieciowe, kamery, systemy alarmowe czy urządzenia automatyki budynkowej. Modernizujemy istniejące już okablowanie oraz tworzymy nowe punkty dystrybucyjne.</p>",
      technologies: "Legrand, Commscope Netconnect, Krone, Emiter",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas server",
      index: 2,
      image: {
        name: "1632263639.webp",
        path: "images/1632263639.webp",
        url: "/images/1632263639.webp"
      }
    },
    {
      id: 2,
      title: "Systemy kontroli dostępu",
      short: "Projektujemy i wykonujemy kompleksowe systemy kontroli dostępu (KD) w oparciu o najnowsze technologie.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Począwszy od małych systemów kilku drzwiowych do systemów obejmujących cały zakład. Integrujemy system KD z już istniejącymi kołowrotkami, tripodami i szlabanami. System kontroli nie musi ogranicza\u0107 się do jednego miejsca, dzięki komunikacji TCP/IP jesteśmy w stanie stworzy\u0107 system obejmujący wiele lokalizacji niezależnie od miejsca, zarządzany przez oprogramowanie zainstalowane na serwerze. Głównymi zaletami takiego systemu jest:<br>- ewidencja osób poruszających się na zakładzie od stałych pracowników do gości z przepustkami tymczasowymi <br> - szybkie odszukanie osoby po przez sprawdzenie ostatniego miejsca użycia karty<br>- zdalne otwieranie i zamykanie drzwi<br>- integracja z Systemami Sygnalizacji Włamanie i Napadu (SSWiN)<br>- integracja z systemami wykrywania pożaru<br>- integracja z systemami telewizji przemysłowej<br>- nadawanie uprawnie\u0144 dostępu do pomieszcze\u0144 indywidualnym osobą lub całym grupą</p>",
      technologies: "Roger, C-Cure, Unicard",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas id-card",
      index: 3,
      image: {
        name: "1632263652.webp",
        path: "images/1632263652.webp",
        url: "/images/1632263652.webp"
      }
    },
    {
      id: 3,
      title: "Systemy Rejestracji Czasu Pracy RCP",
      short: "Zajmujemy się tworzeniem systemów rejestracji czasu pracy, w skład której wchodzą czytniki kart zbliżeniowych oraz oprogramowanie rejestracji odbi\u0107 pracowników zainstalowane na serwerze.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Karty RCP są w pełni kompatybilne z systemami KD. Tworzymy oprogramowanie do raportów czasu pracy szyte na miarę potrzeb i oczekiwa\u0144 klienta co wyróżnia nas na tle innych firm.</p>",
      technologies: "Roger, Unicard",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas clock",
      index: 4,
      image: {
        name: "1632263667.webp",
        path: "images/1632263667.webp",
        url: "/images/1632263667.webp"
      }
    },
    {
      id: 4,
      title: "Systemy wizyjne CCTV i CCTV IP",
      short: "Wykonujemy i projektujemy kompletne systemy telewizji przemysłowej oparte na technologii cyfrowej i analogowej oraz świadczymy usługi z zakresu integracji ich między sobą.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Tworzymy inteligentne systemy telewizji pozwalające na rozpoznawanie tablic rejestracyjnych w samochodach i twarzy lub analitykę obrazu na żywo.</p>",
      technologies: "Bosch, HikVision",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas video",
      index: 5,
      image: {
        name: "1632263678.webp",
        path: "images/1632263678.webp",
        url: "/images/1632263678.webp"
      }
    },
    {
      id: 5,
      title: "Systemy Sygnalizacji Włamania i Napadu SSWiN",
      short: "W skład systemu SSWiN wchodzą czujniki wykrywające ruch (PIR) reagujące na podczerwie\u0144 lub mikrofale, czujniki magnetyczne (kontaktrony) wykrywające otwarcie lub zamknięcie okna, drzwi, bramy.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Elementy te tworzą strefę alarmową którą możemy uzbraja\u0107 i rozbraja\u0107 za pomocą manipulatora, ukrytego przycisku, wysłania SMS\u2019a czy też poprzez aplikację zainstalowaną na urządzeniu mobilnym z oprogramowaniem Android lub iOS. Systemy antynapadowe posiadają opcję cichych alarmów realizowanych przez przycisk napadowy, bezprzewodowy pilot czy też wpisanie specjalnego kodu na manipulatorze, gdy jesteśmy do tego zmuszeni. SSWiN jest na tyle skalowalnym systemem, że może zosta\u0107 wykonany w domku jednorodzinnym czy też w dużym zakładzie. W momencie uruchomienie się alarmu zostaniemy poinformowanie poprzez np. sygnalizator optyczny, sygnalizator akustyczny, SMS z informacją, gdzie nastąpiło naruszenie, powiadomieniami typu push w aplikacji na urządzenia mobile, czy też wysłaniem sygnału do firmy ochroniarskiej. Instalujemy zarówno systemy przewodowe jak i bezprzewodowe.</p>",
      technologies: "Satel",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas user-shield",
      index: 6,
      image: {
        id: 37,
        name: "1632263696.webp",
        path: "images/1632263696.webp",
        url: "/images/1632263696.webp"
      }
    },
    {
      id: 6,
      title: "Systemy telekomunikacyjne",
      short: "Ważną kwestią każdej firmy niezależnie od jej wielkości czy też liczby pracowników jest komunikacja i wymiana informacji, która może by\u0107 realizowana przez centrale telefoniczne.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Posiadamy ponad 20-letnie doświadczenie w tej dziedzinie potwierdzone przez liczne certyfikaty. Opracowujemy koncepcję systemów telekomunikacyjnych od małych firm do całych call center. \u015awiadczymy usługi serwisowe oraz przeprowadzamy modernizację i upgrade systemów. Instalujemy centrale telefoniczne umożliwiające obsługę telefonów analogowych, cyfrowych, IP oraz bezprzewodowych.</p>",
      technologies: "Siemens, Panasonic, Astra (Ericsson)",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas satellite-dish",
      index: 7,
      image: {
        name: "1632263710.webp",
        path: "images/1632263710.webp",
        url: "/images/1632263710.webp"
      }
    },
    {
      id: 7,
      title: "Outsourcing informatyczny",
      short: "Zajmujemy się outsourcingiem usług informatycznych, wdrożeniami, audytami, systemami zabezpiecze\u0144 sieciowych. ",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Tworzymy oprogramowanie na zamówienie klienta. Dzięki wykwalifikowanemu i przeszkolonemu personelowi oraz licencjonowanym narzędziom programistycznym możemy stworzy\u0107 dla Pa\u0144stwa dedykowaną aplikację. \u015awiadczymy usługę tzw. pierwszej linii wsparcia realizowanej poprzez system zgłosze\u0144 HelpDesk polegający na rozwiązywaniu codziennych problemów użytkowników. Opiekujemy się systemami zabezpiecze\u0144 sieciowych chroniących przez atakami hakerów. Projektujemy i wdrażamy informatyczne systemy backupowe wrażliwych danych dzięki czemu mamy pewnoś\u0107, że żadne pliki nie zginą czy też zostaną trwale usunięte. Nasi inżynierzy systemowi zapewniają stałą opiekę serwerów baz danych, terminalowych, mailowych, ERP, Active Directory.</p>",
      technologies: "Microsoft, Fujitsu, ZyXEL, Trend Micro, Apple",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas chart-bar",
      index: 8,
      image: {
        id: 39,
        name: "1632263722.webp",
        path: "images/1632263722.webp",
        url: "/images/1632263722.webp",
      }
    },
    {
      id: 8,
      title: "Serwis teletechniczny",
      short: "\u015awiadczymy usługę opieki nad systemami niskoprądowymi polegającą na przeprowadzaniu przez naszych wykwalifikowanych inżynierów okresowych przeglądów, prac modernizacyjnych, rozbudowy istniejących systemów. ",
      content: "<style>p { text-align: justify; }</style>\r\n<p>Usterki mogą pa\u0144stwo zgłasza\u0107 na nasz system zgłosze\u0144, po otrzymaniu przez nas takiego zgłoszenia natychmiast przechodzimy do działania, aby rozwiąza\u0107 zaistniały problem. Myślimy nieszablonowo i jesteśmy gotowi do podejmowania wyzwa\u0144. Od początku istnienia firmy dowiedliśmy, że nie ma problemów z którymi sobie nie poradzimy poprzez wykwalifikowanych pracowników oraz zaplecza technicznego.</p>",
      technologies: "brak",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas tools",
      index: 9,
      image: {
        id: 40,
        name: "1632263739.webp",
        path: "images/1632263739.webp",
        url: "/images/1632263739.webp"
      }
    },
    {
      id: 9,
      title: "Systemy ERP",
      short: "Zarządzanie zasobami przedsiębiorstwa nigdy nie było tak proste.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>\u015awiadczymy kompleksowe usługi związane z wdrożeniem narzędzi do zarządzania zasobami i procesami biznesowymi takimi jak: sprzedaż, zakupy, zamówienia, produkcja, magazynowanie, zasoby ludzkie, obieg dokumentów, analityka i zarządzanie.</p>",
      technologies: "Comarch",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas laptop",
      index: 10,
      image: {
        id: 41,
        name: "1632263753.webp",
        path: "images/1632263753.webp",
        url: "/images/1632263753.webp"
      }
    },
    {
      id: 10,
      title: "Fotowoltaika",
      short: "Odnawialne źródła energii od zawsze budziły nasze zainteresowania.",
      content: "<!-- Wszystko, co jest napisane w tych tagach jest komentarzem i nie zostanie wyrenderowane w widoku strony. -->\r\n\r\n<!-- Tutaj, w tagu <style>, określone zostało wyjustowanie tekstu dla wszystkich tagów <p>, czyli paragrafów. -->\r\n<style>p { text-align: justify; }</style>\r\n\r\n<p>W swej działalności TELNET skupił się na pozyskiwaniu energii z promieniowania słonecznego. Instalacja fotowoltaiczna powinna by\u0107 zaprojektowana tak, aby pracowała przez lata i wypracowała jak najwięcej energii elektrycznej. Dlatego warto inwestowa\u0107 w fotowoltaikę dobrej jakości. Pozorne oszczędności na etapie kupna i montażu instalacji mogą okaza\u0107 się kosztowne w skutkach. Tanie produkty, słabej jakości, nieznanych producentów dają niższy zysk energetyczny i wyższe ryzyko występowania wad ukrytych. Wybór produktów znanych i pewnych producentów zapewnia stabilną produkcję energii elektrycznej i bezpiecze\u0144stwo w całym okresie życia instalacji oraz możliwoś\u0107 rozwoju instalacji. W swej ofercie posiadamy panele PV najlepszych producentów takich jak Canadian Solar czy JA Solar.</p>\r\n\r\n<p>JA Solar Holdings Co. Ltd jest wiodącym producentem ogniw od 2010 roku, a w 2012 umocnił swoją pozycję jako dostawca modułów TIER1. Firma znajduje się na liście NASDAQ. Dzięki zaangażowaniu w badania naukowe, JA Solar stał się właścicielem ponad 314 patentów, co przekłada się na produkcję innowacyjnych modułów najwyższej jakości. JA Solar we współpracy z Szanghajskim Instytutem Fizyki Technicznej Chi\u0144skiej Akademii Nauk powołał \u201eCentrum Bada\u0144 Nad Innowacyjnością Fotowoltaiki\u201d i nawiązał długoterminową współpracę z ośrodkami badawczymi w USA, Holandii i Australii. Od 2017 roku JA Solar oferuje innowacyjne panele wykorzystujące ogniwa połówkowe oraz dwu stronne szkło-szkło w ramie.</p>\r\n\r\n<!-- Ten obrazek będzie rozciągał się na 100% szerokości opisu oferty, a jego wysokoś\u0107 będzie automatyczna, patrz atrybut \"style\". (komentarz) -->\r\n<img style=\"width: 100%; height: auto;\" src=\"https://telnet.com.pl/images/fotowoltaika2.jpeg\" alt=\"Nie można załadowa\u0107 obrazka!\">\r\n\r\n\r\n<p>JA Solar<br>\r\n<ul>\r\n    <li>Nagroda TOP PV Brand dla JA Solar</li>\r\n    <li>Wiodąca marka modułów PV</li>\r\n    <li>Gwarancja na produkt 12 lat</li>\r\n    <li>Gwarancja na wydajnoś\u0107 25 lat</li>\r\n    <li>Rewelacyjna wydajnoś\u0107 w warunkach niskiego natężenia promieniowania</li>\r\n    <li>Wysoka sprawnoś\u0107</li>\r\n    <li>Gwarantowana dodatnia tolerancja mocy (do +5W)</li>\r\n    <li>Odpornoś\u0107 na degradację napięciem indukowanym (PID) zgodna z IEC62804</li>\r\n    <li>Doskonała jakoś\u0107 potwierdzona niezależnymi badaniami i certyfikatami</li>\r\n</ul>\r\n<div style=\"text-align: center;\">\r\n<img style=\"width: 300px; height: 300px;\" src=\"https://telnet.com.pl/images/motyl.png\" alt=\"Nie można załadowa\u0107 obrazka!\">\r\n</div>\r\n</p>\r\n\r\n<p>Kolejnym bardzo ważnym elementem instalacji jest falownik fotowoltaiczny. To dzięki falownikom jesteśmy w stanie wykorzysta\u0107 energię z promieni słonecznych. To one zamieniają produkowaną przez panele fotowoltaiczne energię elektryczną w postaci prądu stałego na energię elektryczną w postaci prądu przemiennego, identycznego jak w gniazdkach elektrycznych i synchronizują się z siecią elektroenergetyczną. Dziś falownik nie jest tylko prostym urządzeniem zamieniającym prąd stały na przemienny i komunikującym swe parametry poprzez wyświetlacz LCD lecz jest wręcz mikrokomputerem połączonym z siecią lokalną i zapewniającym dwustronną komunikację poprzez WiFi, Bluetooth czy inne protokoły gwarantującym rozbudowane dane o stanie całej instalacji. Wobec tego falownik można porówna\u0107 do serca i centralnego układu nerwowego całej instalacji. Dlatego jego prawidłowy wybór może decydowa\u0107 o technicznym i finansowym powodzeniu całej inwestycji. Aby sprosta\u0107 temuwyzwaniu posiadamy w swej ofercie urządzenia najlepszych producentów takich jak: ZeverSolar czy Huawei. </p>\r\n\r\n<p><b>Zevresolar</b> to jeden z największych chi\u0144skich producentów fotowoltaicznych falowników stringowych do zastosowa\u0144 domowych i przemysłowych. Firma została założona w 2007 roku, a od 2013 roku należy do niemieckiego SMA Solar Technology AG - największego producenta falowników na świecie. Produkty Zeversolar łączą niemiecką myśl techniczną, jakoś\u0107 i niezawodnoś\u0107 z chi\u0144skim doświadczeniem w wielkoskalowej produkcji i optymalizacji kosztów wytwarzania. W ofercie Zeversolar znajdziemy kompletną gamę falowników fotowoltaicznych: zarówno nowatorskie falowniki jednofazowe Zeverlution o mocach 1-4 kW (najlżejsze falowniki na rynku \u2013 tylko 7,3 kg) jak i falowniki trójfazowe Evershine o mocach 4-33 kW przeznaczone do zastosowa\u0144 domowych jak i przemysłowych.</p>\r\n\r\n<!-- Kontener <div> wyśrodkowujący obrazek w nim zawarty. (komentarz)-->\r\n<div style=\"text-align: center;\">\r\n<!-- Tutaj są już ustalone wymiary obrazka. (komentarz) -->\r\n<img style=\"width: 300px; height: 300px;\" src=\"https://telnet.com.pl/images/fotowoltaika3.png\" alt=\"Nie można załadowa\u0107 obrazka!\">\r\n</div>\r\n<!-- Tutaj wstawiłem złamanie linii <br> ponieważ obrazek pokazywał się zbyt blisko kolejnego paragrafu, skutkuje to pustym wierszem. Alternatywnym rozwiązaniem dla tego byłoby ustawienie marginesu dolnego dla kontenera <div> powyżej. (komentarz) -->\r\n<br>\r\n\r\n<p><b>Huawei</b> jest wiodącą globalną firmą w dziedzinie technologii informacyjnej i komunikacyjnej. Produkty i rozwiązania Huawei są wykorzystywane w ponad 170 krajach i regionach, obsługujących ponad jedną trzecią populacji światowej.\u2028 \u2028W branży fotowoltaiki, Huawei oferuje zaawansowane technicznie falowniki, charakteryzujące się wysoką jakością i niezawodnością. Przeznaczone są zarówno do mikroinstalacji (grupa Fusion Home), jak i do bardzo dużych instalacji (Grupa commercial).</p>\r\n\r\n<!-- Sytuacja identyczna do powyższej. (komentarz) -->\r\n<div style=\"text-align: center;\">\r\n<img style=\"width: 300px; height: 300px;\" src=\"https://telnet.com.pl/images/fotowoltaika4.png\" alt=\"Nie można załadowa\u0107 obrazka!\">\r\n</div>",
      technologies: "Canadian Solar, JA Solar",
      visible: 1,
      large: 1,
      highlighted: 1,
      iconName: "fas solar-panel",
      index: 1,
      image: {
        id: 32,
        name: "1632263627.webp",
        path: "images/1632263627.webp",
        url: "/images/1632263627.webp"
      }
    },
    {
      id: 11,
      title: "Pozostałe systemy i usługi",
      short: "Oferowane przez nas systemy wcześniej nie wymienione.",
      content: "<style>p { text-align: justify; }</style>\r\n<p>- kompleksowe instalacje elektryczne,<br>- systemy przeciwpożarowe,<br>- systemy nagłośnieniowe,<br>- pomiary termowizyjne,<br>- systemy transmisji obrazu i dźwięku.</p>",
      technologies: "Siemens, Esser, Polon, Kramer, Fujitsu",
      visible: 1,
      large: 0,
      highlighted: 0,
      iconName: "fas asterisk",
      index: 11,
      image: {
        id: 42,
        name: "1632263764.webp",
        path: "images/1632263764.webp",
        url: "/images/1632263764.webp"
      }
    }
  ],
  historyEntries: [
    {
      id: 14,
      content: "Telnet wdrożył system pomiaru wiatru pozwalający ocenić opłacalność ekonomiczną przydomowej instalacji wiatrowej.",
      link: "<a href='https://pomiar-wiatru.pl/'>https://pomiar-wiatru.pl/</a>",
      date: "2024-03-14",
      image: null
    },
    {
      id: 13,
      content: "Spółka Telemetro zmienia nazwę na \"Techmont Serwis\" i przenosi siedzibę do Dąbrowy Górniczej.",
      date: "2019-01-01"
    },
    {
      id: 12,
      content: "Spółka zwiększa zakres swojej działalności o systemy ERP firmy Comarch",
      date: "2016-01-01"
    },
    {
      id: 11,
      content: "Spółka zwiększa zakres swojej działalności o systemy sygnalizacji pożaru",
      date: "2012-01-01"
    },
    {
      id: 10,
      content: "Spółka sprzedaje udziały w firmie Intelix Sp. z o. o.",
      date: "2011-01-01"
    },
    {
      id: 9,
      content: "Spółka kupuje 100% udziałów w firmie Telemetro Sp. z o. o. (integrator systemów teleinformatycznych z siedzibą w Krakowie) oraz sprzedaje udziały w spółce Global One Sp. z o. o.",
      date: "2010-01-01"
    },
    {
      id: 8,
      content: "Spółka zwiększa swoje zaangażowanie w firmie Eurotelix do 75%.",
      date: "2009-01-01"
    },
    {
      id: 5,
      content: "Spółka otrzymuje najwyższy status handlowy i serwisowy firmy Siemens Platinum Partner",
      date: "2007-01-01"
    },
    {
      id: 6,
      content: "Spółka Telnet dokonuje zakupu siedziby w Katowicach.",
      date: "2007-01-01"
    },
    {
      id: 7,
      content: "Spółka zostaje udziałowcem w firmie Global One Sp. z o. o. (integrator systemów teleinformatycznych z siedzibą w Warszawie).",
      date: "2007-01-01"
    },
    {
      id: 4,
      content: "Spółka zostaje udziałowcem w firmie Intelix (producent systemów taryfikacyjnych iTAR i IBB).",
      date: "2004-01-01"
    },
    {
      id: 3,
      content: "Połączenie spółek Telnet Spółka Cywilna i Telnet Systemy Teleinformatyczne Sp. z o. o.",
      date: "2002-01-01"
    },
    {
      id: 2,
      content: "Powstanie spółki Telnet Systemy Teleinformatyczne Sp. z o. o.",
      date: "2000-01-01"
    },
    {
      id: 1,
      content: "Powstanie Spółki Cywilnej Telnet Paweł Seryło, Paweł Nowak, Tomasz Nowak.",
      date: "1999-01-01"
    }
  ],
  footer: {
    content: "TELNET Systemy Teleinformatyczne Sp. z o. o.<br>ul. Witosa 21 40-832 Katowice<br>tel.: 32 2013640<br>fax.: 32 2013641<br>e-mail: biuro@telnet.com.pl<br><br>NIP: 634-24-48-882<br>Regon.: 277634715<br>S\u0105d Rejonowy Katowice \u2013 Wsch\u00f3d w Katowicach Wydzia\u0142 VIII Gospodarczy Krajowego Rejestru S\u0105dowego Nr KRS 0000013816; Kapita\u0142 Zak\u0142adowy: 201.600,00 PLN",
    phone: "322013640",
    email: "biuro@telnet.com.pl",
    hq_coords: {
      lat: 50.259623,
      lng: 18.970732
    }
  }
};
